module.exports = __webpack_public_path__ + "static/media/workingmemory-words-11.f213ee4a.mp3";